import { modalLoadingSetter } from './store';

export async function loadingWrapperPromise<T>(promise: Promise<T>) {
  modalLoadingSetter({ loadingVisible: true });

  try {
    const res = await promise;
    return res;
  } finally {
    // Siempre quitar el loading, sin importar si hubo éxito o error
    modalLoadingSetter({ loadingVisible: false });
  }
}
